import { render, staticRenderFns } from "./Chart3DPie.vue?vue&type=template&id=67052dd9&scoped=true"
import script from "./Chart3DPie.vue?vue&type=script&lang=js"
export * from "./Chart3DPie.vue?vue&type=script&lang=js"
import style0 from "./Chart3DPie.vue?vue&type=style&index=0&id=67052dd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67052dd9",
  null
  
)

export default component.exports